import api from 'api/apiInstance';

export function practiceAdminResendApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
